(() => {
  'use strict';
  const root = document.querySelector('[data-st-brew-page]');
  if (!root || window.Shopify?.designMode || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';
  const route = '/pages/brew-tractor-beam';
  const version = root.dataset.pageVersion;
  const player = root.querySelector('video');
  let viewed = false;
  const progressSeen = new Set();
  function allowed() {
    try { return location.pathname.replace(/\/$/, '') === route && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && window.posthog?.__loaded === true; }
    catch (_) { return false; }
  }
  function emit(name, extra = {}) {
    if (!allowed()) return false;
    const params = new URLSearchParams(location.search);
    const context = {page_version:version, clip_id:'tony-tractor-beam-20261014', asset_revision:root.dataset.assetRevision, ...extra};
    for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']) if (params.get(key)) context[key] = params.get(key);
    if (params.get('st_qa') === '1' || sessionStorage.getItem('st_posthog_qa_v1') === '1') context.st_qa = true;
    window.posthog.capture(name, context);
    return true;
  }
  function pageView() { if (!viewed && emit('st_brew_page_view')) viewed = true; }
  pageView();
  let attempts = 0;
  const readiness = setInterval(() => { pageView(); if (viewed || ++attempts >= 30) clearInterval(readiness); }, 1000);
  document.addEventListener('visitorConsentCollected', pageView);
  player?.addEventListener('play', () => { pageView(); emit('st_brew_video_play'); });
  player?.addEventListener('pause', () => { if (!player.ended) emit('st_brew_video_pause', {position_seconds:Math.round(player.currentTime)}); });
  player?.addEventListener('timeupdate', () => {
    if (!(player.duration > 0)) return;
    const percent = player.currentTime / player.duration * 100;
    for (const milestone of [25,50,75]) if (percent >= milestone && !progressSeen.has(milestone) && emit('st_brew_video_progress',{milestone})) progressSeen.add(milestone);
  });
  player?.addEventListener('ended', () => emit('st_brew_video_complete'));
  root.querySelector('details')?.addEventListener('toggle', event => { if (event.currentTarget.open) emit('st_brew_specs_open'); });
  root.querySelectorAll('[data-st-brew-link]').forEach(link => link.addEventListener('click', () => emit('st_brew_link_click', {link_id:link.dataset.stBrewLink})));
})();
